import { Component, h, Host, Element, Prop, Event, EventEmitter, State } from '@stencil/core';
import ArrowDown from '../icons/arrow-down';

@Component({
  tag: 'zpr-carousel-vertical-item'
})
export class ZprCarouselVerticalItem {

  private imageContainer:Element;
  private textContainer:Element;

  @Element() el: HTMLElement;

  @Prop({ reflect: true }) open?: boolean = false;

  @State() slotTitle:any;
  @State() slotContent:any;
  @State() slotImage:any;

  @State() isCheckerboard:boolean = false;

  @Event({composed:true}) onOpen: EventEmitter;

  componentWillLoad(){
    this.adjustForMobile();

    window.addEventListener('resize',()=>{
      this.adjustForMobile()

      if(this.isCheckerboard) this.renderAsBoard()
      else this.renderAsSlide()
    })
    
    const parentCarouselVerticalEl = this.el.closest('zpr-carousel-vertical')
    parentCarouselVerticalEl.addEventListener('onOpen', (ev:any)=>this.itemChanged(ev))

    this.slotTitle = this.el.querySelector('[slot="title"]')
    this.slotContent = this.el.querySelector('[slot="content"]')
    this.slotImage = this.el.querySelector('[slot="image"]')
  }

  componentDidLoad(){
    if(this.isCheckerboard) this.renderAsBoard();
    else this.renderAsSlide();
  }
  renderAsBoard(){
    const mediaContainer = this.el.querySelector('.media-container');

    if(mediaContainer){
      this.el.querySelector('.media-container').innerHTML = '';
      this.slotImage.removeAttribute('hidden');
      this.slotImage.className = '';
      mediaContainer.append(this.slotImage);
    }
  }
  renderAsSlide(){
    const fragment = document.createDocumentFragment();
    const itemTitle = document.createElement('div');

    itemTitle.classList.add('item-title');
    itemTitle.append(this.slotTitle);

    const itemContent = document.createElement('div');
    itemContent.classList.add('item-content');
    itemContent.append(this.slotContent);

    fragment.append(itemTitle)
    fragment.append(itemContent)
    this.textContainer.innerHTML = ''
    this.textContainer.append(fragment);

    this.slotImage.setAttribute('hidden', true)
    this.bindEvents()

  }

  bindEvents(){
    const titles = this.el.querySelectorAll('.item-title');
    for(let title of titles){
      title.addEventListener('click', ()=>this.setOpen())
    }
  }

  itemChanged(ev:CustomEvent){
    this.el.removeAttribute('open');
    let tab = ev.detail.item;
    tab.setAttribute('open', "true");
  }

  setOpen(v = true) {
    this.onOpen.emit({
      "item":this.el,
      "image":this.slotImage
    })
  }

  adjustForMobile() {
    this.isCheckerboard = window.innerWidth < 1024;
  }

  render() {
    return (
      <Host class={{
        "checkerboard-container":this.isCheckerboard,
        "open":this.open && !this.isCheckerboard
      }}>
        <div class={{
          "checkerboard-grid":this.isCheckerboard
        }}>
          <div class={{
            "media-container":this.isCheckerboard
          }} ref={el => this.imageContainer = el as HTMLElement} >
            <slot name="image"></slot>
          </div>
          <div class={{
            "text-container":this.isCheckerboard
          }} ref={el => this.textContainer = el as HTMLElement}>
            <slot name="title"></slot>
            <slot name="content"></slot>
          </div>
        </div>
      </Host>
    )
  }
}